import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './css/modules/Logo.module.css';

/**
 * Logo w nagłówku: poziomy lockup - tarcza kompasu z logo marki plus napis.
 * Pełny znak (z samolotem i skrzydłami) ma proporcje 4:3 i w pasku nagłówka
 * albo się nie mieścił, albo był przycinany, dlatego do nagłówka idzie wersja
 * pozioma. Pełny znak zostaje w og-pilotuje.png i na grafikach społecznościowych.
 */
const Logo = () => {
  const navigate = useNavigate();

  const navigateToHome = () => {
    navigate('/');
  };

  return (
    <div className={styles.logoContainer} onClick={navigateToHome}>
      <picture>
        <source srcSet="/pilotuje_logo.webp" type="image/webp" />
        <img
          src="/pilotuje_logo@2x.png"
          alt="Pilotuje.pl - testy do egzaminów dla pilotów"
          width="170"
          height="40"
          decoding="async"
        />
      </picture>
    </div>
  );
};

export default Logo;
